const MAX_EMAIL_LENGTH = 254;

/**
 * Produces the stable identity used by both browser and server-side PostHog events.
 * Email is already the minitools identity; normalizing it prevents casing or whitespace
 * differences from splitting one person into multiple PostHog profiles.
 */
export function normalizePostHogEmail(value: unknown): string | undefined {
  if (typeof value !== 'string') return undefined;

  const email = value.trim().toLowerCase();
  if (!email || email.length > MAX_EMAIL_LENGTH || !/^[^\s@]+@[^\s@]+$/.test(email)) {
    return undefined;
  }

  return email;
}
